//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/ToolDesigner.js";
import "../no/Builder.js";
import "../no/SelectTaggedObject.js";
import "../no/SelectTaggedObjectList.js";
import "../no/ugmath.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[1,"ProductSelection",0,"SelectTaggedObject",0],[1,"SearchByProductSelection",0,"SelectTaggedObjectList",0],[0,"SearchTypes",1,0],[0,"XSumInteger",1,0],[0,"YSumInteger",1,0],[0,"ZSumInteger",1,0]],[[["productSelection"],"SetProductSelection",{},1,0],[[],"ClearProductSelection",{},0,0],[["productSelection"],"SetSearchByProductSelection",{},1,0],[[],"ClearSearchByProductSelection",{},0,0],[[],"AddDatumsButton",{},0,0],[[],"RemoveDatumsButton",{},0,0],[[],"PopulateUnselectedDatumsList",{},0,0],[["nDatums","datums"],"InitAssaignedDatumsForProductList",{},0,0],[["nDatums","datums"],"GetAvaiableDatums",{},0,0],[["selections"],"Assign",{},1,0],[["selections"],"UnAssign",{},1,0],[["removeAssignDatums"],"RemoveDatumsFromSession",{},1,0],[["bottomVertex","upperVertex","selectedObject"],"VolumeSearch",{},3,0],[["enum0","searchValue"],"SearchDatumsInStationByProperty",{},2,0],[[],"PrintAutoTestResults",{},0,0],[["dfDatum"],"CreateConesForDatums",{},1,0]],[]];
SPLM.ToolDesigner.SelectDatumsBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.ToolDesigner.SelectDatumsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.ToolDesigner.SelectDatumsBuilder.DatumCleanAPINames = Object.freeze({
    "Available" : "Available", "AssaignedPro" : "AssaignedPro", "AssaignedStation" : "AssaignedStation"});

SPLM.ToolDesigner.SelectDatumsBuilder.ConesDir = Object.freeze({
    "XDir" : "XDir", "YDir" : "YDir", "ZDir" : "ZDir"});

SPLM.ToolDesigner.SelectDatumsBuilder.SearchOption = Object.freeze({
    "StationID" : "StationID", "StationName" : "StationName", "OriginalProduct" : "OriginalProduct", "SpecificProduct" : "SpecificProduct", "VolumeScope" : "VolumeScope"});

SPLM.ToolDesigner.SelectDatumsBuilder.Type = Object.freeze({
    "Id" : "Id", "Name" : "Name"});

export default SPLM;